<template>
	<aside
		class="tw:[box-shadow:0px_1px_1px_1px_rgb(62_62_62)] tw:overflow-hidden tw:w-[18vmax] tw:max-w-[24vmax]
			tw:ml-auto tw:flex tw:flex-col">
		<slot> </slot>
	</aside>
</template>
